import { Component, HostBinding, Input } from '@angular/core';

import { PopoverController } from '@ionic/angular';
import { AbstractModalWithResult } from '../../abstract-modal-with-result';
import { SelectIonicPopoverOption } from './select-ionic-popover-option';

@Component({
  selector: 'app-select-ionic-popover',
  templateUrl: './select-ionic-popover.component.html',
  styleUrls: ['./select-ionic-popover.component.scss'],
})
export class SelectIonicPopoverComponent<T> extends AbstractModalWithResult<T | T[]> {
  static modalId = 'SelectIonicPopoverComponent';

  @Input() options: SelectIonicPopoverOption<T>[];
  @Input() @HostBinding('class.multiple') multiple: boolean;
  @Input() onChangeFn: (value: T | T[]) => void; // optional (but the only way to get the selected values in case 'multiple' is true)

  constructor(popoverController: PopoverController) {
    super(popoverController);
  }

  getModalId() {
    return SelectIonicPopoverComponent.modalId;
  }

  optionClicked(clicked: SelectIonicPopoverOption<T>) {
    if (this.multiple) {
      clicked.isSelected = !clicked.isSelected;
    } else {
      for (const option of this.options) {
        option.isSelected = option === clicked;
      }
      super.ok(clicked.value); // some callers use the AbstractModalWithResult mechanism
    }
    if (this.onChangeFn) {
      const value = this.multiple
        ? this.options.filter(option => option.isSelected).map(option => option.value)
        : this.options.find(option => option.isSelected).value;
      this.onChangeFn(value); // <app-select-ionic> uses the onChangeFn mechanism
    }
  }
}
